import { createSelector } from 'reselect'

import { RootState } from '~/core/store/root.reducer'

const getTheme = (state: RootState) => state.theme

export const selectTheme = createSelector(getTheme, (theme) => theme)

export default selectTheme
